import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../../design";
import { Col, Row } from "react-awesome-styled-grid";
import TransactionModal from "../../../components/modal/transaction";
import SuccessModal from "../../../components/modal/success";
import RecaptchaModal from "../../../components/recaptcha";
import {
    addEventPageOrderChargeById,
    BASE_URLS,
    declinePaymentLinkByGid,
    expireHoldToken,
    getCheckoutCardCharges,
    getCheckoutReconnection, getEventPageOrderDetailsById,
    getQrPaymentReconnection,
    getSecretValuesById,
    eventPageSplitUp,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../../api";
import {
    MESSAGES,
    NETBANKING_LIST,
    QR_STATUSES,
    REFRENCE_ID_LENGTH,
    SESSION_TIME,
    SWIREPAY_URL,
    TabNames,
} from "../../../appconstants";
import { AmountDivideByHundred } from "../../../helper";
import BaseSplitPage from "../../../components/splitpage";
import Header from "./smallscreen/header";
import currencyFormatter from "../../../utils/currencyformatter";
import CardPayment from "../../../components/cardpayment/CardPayment";
import Support from "../../../components/support";
import SmallScreenFooter from "../../../components/footer";
import getMenuTabs from "../../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../../utils/getUniquePaymentTypes";
import UpiPayment from "../../../components/UpiCheckout/UpiCheckout";
import AchPayment from "../../../components/achPaymentWithPlaid";
import InstantPayment from "../../../components/instantpayment/InstantPayment";
import BankPayment from "../../../components/bankpayment/BankPayment";
import NetBanking from "../../../components/netbanking/NetBanking";
import GooglePay from "../../../components/googlePay/GooglePay";
import PayPalCheckout from "../../paypalCheckout";
import PaymentExpandableRows from "../../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../../components/PaymentExpandableRowsV2";
import AlertModal from "../../../components/modal/alert";
import WARNING_ICON from "../../../assets/imgs/exclamation_warning.svg"
import SUCCESS_ICON from "../../../assets/imgs/success.svg";
import EPaymentImg from "../../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../../assets/imgs/OmegaITRlogo.png";
import ApplePay from "../../../components/applePay/ApplePay";
import Apple from '../../../routes/apple';
import parsePhoneNumberFromString, { getCountryCallingCode } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../../redux/customerDetailsInfo";
import ApplePayButton from '../../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../../components/payPalGooglePay";
import SavedPaymentMethods from "../../../components/SavedPaymentMethods";
import { getCountryCodeAndNumber } from "../../../utils/getCountryCodeAndNumber";
import { setFormData } from "../../../redux/appConfigInfo";
import { useCallback } from "react";
import { useMemo } from "react";

type Props = {
    history: {
        push: Function,
    },
}

const EventPagePay = (props: Props) => {

    const { match: { params: { eventPageOrderLinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${eventPageOrderLinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [convenience, setConvenience] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(null);
    const [userType, setUserType] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [supportPhoneNumber, setSupportPhoneNumber] = useState(null);
    const [upiError, setUpiError] = useState('');
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [applePayment, setApplePayment] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [shippingAddress, setShippingAddress] = useState(null)
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const [net, setNet] = useState(null);
    const [feeService, setFeeService] = useState(null);
    const [finalTax, setFinalTax] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [totalPayableAch, setTotalPayableAch] = useState(null);
    const [caluclation, setCaluclation] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [finalTip, setFinalTip] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [serviceFeeVal, setServiceFeeVal] = useState(null);
    const [serviceFeeRateVal, setServiceFeeRateVal] = useState(null);
    const [finalAmount, SetFinalAmount] = useState(null);
    const [taxValue, setTaxValue] = useState(null);
    const [taxPercentage, setTaxPercentage] = useState(null);
    const [surcharge, setSurcharge] = useState(null);
    const [serviceFeeRate, setServiceFeeRate] = useState(false);
    const [serviceFee, setServiceFee] = useState(false);
    const [updatedCardNum, setUpdatedCardNum] = useState('');
    const [optionalCheck, setOptionalCheck] = useState(true);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkGlobalRecaptcha, setPaymentLinkGlobalRecaptcha] = useState(null);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const accountGid = [
        'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${eventPageOrderLinkId}`) || undefined);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [paypalGooglePayRecaptchaToken, setPaypalGooglePayRecaptchaToken] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();

  const ossatId = [
    "eventpageorderlink-94d9318db7414a2bbbf5c57a8a593277",
  ];

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    useEffect(() => {
        if (payment?.account?.gid) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    useEffect(() => {
        if (updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails) {
            if (updateCustomerRedux?.customerDetails?.name && updateCustomerRedux?.customerDetails?.name !== '') {
                setPayment((prev) => ({ ...prev, eventPageOrder: { ...prev?.eventPageOrder, customer: { ...prev?.eventPageOrder?.customer, name: updateCustomerRedux.customerDetails.name } } }));
            };
            if (updateCustomerRedux?.customerDetails?.email && updateCustomerRedux?.customerDetails?.email !== '') {
                setPayment((prev) => ({ ...prev, eventPageOrder: { ...prev?.eventPageOrder, customer: { ...prev?.eventPageOrder?.customer, email: updateCustomerRedux.customerDetails.email } } }));
            };
            if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
                && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1') {
                setPayment((prev) => ({ ...prev, eventPageOrder: { ...prev?.eventPageOrder, customer: { ...prev?.eventPageOrder?.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } } }));
            };
            dispatch(setUpdateStatus(false));
        };
    }, [updateCustomerRedux]);

    useState(() => {
        if (window.ApplePaySession) {
            setIsApplePay(true);
        }
    }, []);

    const expiredToken = () => {
        const seats = sessionStorage.getItem('seatsio') ? JSON.parse(sessionStorage.getItem('seatsio')) : undefined;
        if (seats?.holdToken) {
            expireHoldToken(seats.holdToken);
        }
        sessionStorage.removeItem('seatsio');
        sessionStorage.removeItem("expiryTime");
        if (payment?.eventPageOrder?.eventPageGid) {
            sessionStorage.removeItem('placedItems-' + payment.eventPageOrder.eventPageGid.replace('eventpage-', ''));
            const prefix = 'placedLineItems-' + payment.eventPageOrder.eventPageGid.replace('eventpage-', '');

            Object.keys(sessionStorage).forEach((key) => {
                if (key.startsWith(prefix)) {
                    sessionStorage.removeItem(key);
                }
            });
        }
    };

    useEffect(() => {
        getEventOrderDataWithoutSearchValue();
    }, [eventPageOrderLinkId, search]);

    // useEffect(() => {

    //     getSplitUp(payment?.eventPageOrder?.eventPageGid);
    // }, [localStorage.getItem(`${eventPageOrderLinkId}-tap-index`)]);

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        getData();
    }, []);

    const setPaymentOrder = (account) => {
        if (account.supportedPaymentTypes) {
            let paymentOrder = getUniquePaymentTypes(account.supportedPaymentTypes);
            if (account.paymentTypeOrder) {
                paymentOrder = [
                    ...account.paymentTypeOrder
                        .map((paymentType1) => {
                            const found = paymentOrder.find((paymentType) => paymentType.category === paymentType1.category);
                            return found ? { category: found } : null;
                        })
                        .filter(Boolean),
                    ...paymentOrder
                        .filter((paymentType) =>
                            !account.paymentTypeOrder.some((paymentType1) => paymentType.category === paymentType1.category)
                        )
                        .map((paymentType) => ({ category: paymentType }))
                ];
            }
            setPaymentTypeOrder(paymentOrder);
        } else {
            setPaymentTypeOrder([{ category: 'CARD' }]);
        }
    }

    useEffect(() => {
        if (payment?.account) {
            const { account, eventPageOrder } = payment;
            if (account.currency && eventPageOrder.total) {
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(eventPageOrder.total), account.currency.name)}`);
                setTotalAmount(currencyFormatter(AmountDivideByHundred(eventPageOrder.total), account.currency.name));
            }
            getSplitUp(payment?.eventPageOrder?.eventPageGid, localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) ? localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) : 0, '');
            setSupportedPaymentTypes(account.supportedPaymentTypes);
            setApplePayment(account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            setSwirepayUS(account.supportedPaymentTypes.includes('SWIREPAY_US'));
            setGooglePayUs(account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
            setPaymentOrder(account);
            setSupportPhoneNumber(payment && payment.support && payment.support.phone);
        }
    }, [payment]);

    useEffect(() => {
        setErrorMessage(null);
        if (payment && payment.account.currency && payment.eventPageOrder.total) {
            setServiceFeeRateVal((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100);
            setServiceFeeVal(AmountDivideByHundred(serviceFee));
            SetFinalAmount(`${payment.amount?.currency?.prefix} ${totalPayable || 0}`)
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency.name)}`);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency.name));
        }
        setConvenience(0);
        setGst(0);
    }, [selectedTab]);

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) {
                errorEl.scrollIntoView();
            }
        }
    };

    const getPaymentCharges = async (cardNumber, payments) => {
        setPayment(payments);
        const customerPhone = getCountryCodeAndNumber(payment?.eventPageOrder?.customer?.phoneNumber);
                const labelFields = {};
                payment?.eventPageOrder?.eventPageOrderLabels?.forEach(labelItem => {
                    if (labelItem?.dataType === 'INPUT_PHONE') {
                        const phoneNumber = parsePhoneNumberFromString(labelItem?.value);
                        labelFields.countryCallingCode = phoneNumber?.countryCallingCode || '1';
                        labelFields.phone = phoneNumber?.nationalNumber;
                    }
                    if (labelItem?.dataType === 'INPUT_EMAIL') {
                        labelFields.email = labelItem?.value;
                    }
                    if (labelItem?.dataType === 'INPUT_NAME' && !labelFields.name) {
                        labelFields.name = labelItem?.value;
                    }
                });
                const disablePhoneOnPromo = !!(((customerPhone?.phoneNumber &&  customerPhone?.countryCode)
                    || (labelFields?.countryCallingCode && labelFields?.phone))
                    && payment?.eventPageOrder?.promoCode);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                      phoneNumber: customerPhone?.phoneNumber || labelFields?.phone,
                      countryCode: labelFields?.countryCallingCode ? `+${labelFields?.countryCallingCode}` : customerPhone?.countryCode,
                      name: payment?.eventPageOrder?.customer?.name || labelFields?.name,
                      email: payment?.eventPageOrder?.customerr?.email || labelFields?.email,
                      disablePhone: disablePhoneOnPromo,
                  } 
                }));
        try {
            const value = await getCheckoutCardCharges(eventPageOrderLinkId, cardNumber);
            if (value) {
                setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
                setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
                setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency.name)}`)
                setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency.name));
            }
        } catch (e) {
            setConvenience(0);
            setGst(0);
            setTotalAmount(currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency.name));
        } finally {
            setShowSpinner(false)
        }
    }


    const updateSurcharge = (val) => {
        getSplitUp(payment?.eventPageOrder?.eventPageGid, localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) ? localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) : 0, updatedCardNum, val);
    }

    const getCurrentTab = (tabName) => {
        getSplitUp(payment?.eventPageOrder?.eventPageGid, tabName, '');
    };

    const getCardNum = (cardNum) => {
        setUpdatedCardNum(cardNum);
        getSplitUp(payment?.eventPageOrder?.eventPageGid, localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) ? localStorage.getItem(`${eventPageOrderLinkId}-tab-name`) : 0, cardNum);
    };

    const getSplitUp = async (metaGid, tabName, cardNum, val) => {
        const tipInfo = localStorage.getItem('eventsPayload') ? JSON.parse(localStorage.getItem('eventsPayload')) : {};
        const payload = {
            eventPageGid: metaGid,
            eventPageOrderLineItems: payment?.eventPageOrder?.eventPageOrderLineItems || [],
            amount: payment?.eventPageOrder.total,
            paymentType: (tabName !== 'CARD' && !cardNum) ? tabName : (cardNum ? 'CARD' : ''),
            cardNumber: tabName === 'CARD' ? cardNum : '',
            surchargeApplicable: (payment?.eventPage?.surchargeEnabled && payment?.account?.surchargeType && payment?.account?.surchargeType !== 'NONE') ? true : false,
            promoCode: tipInfo?.promoCode,
            tip: tipInfo?.tip,
            tipType: tipInfo?.tipType
        }
        if (val === true || val === false) {
            setOptionalCheck(val)
            payload.surchargeApplicable = val;
        }
        try {
            const value = await eventPageSplitUp(payload);
            setNet(value.net);
            setFeeService(value.serviceFee);
            setFinalTax(value.tax);
            setTotalPayable(value.netPayable);
            setCaluclation(value);
            setFinalTip(value.tipAmount);
            setDiscount(value.orderDiscount);
            setSubTotal(value.subTotal);
            setSurcharge(value.surcharge);
            setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(value.netPayable), payment.account.currency.name)}`)
        } catch (reason) {
            error(reason);
        }
    }

    const getEventOrderDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventPageOrderDetailsById(eventPageOrderLinkId, null);
            if (value) {
                if (value.eventPageOrder?.paymentStatus !== 'UN_PAID') {
                    props.history.push(`${pathname}/expired`);
                }
                value.currency = value?.account?.currency;
                value.amount = value?.eventPageOrder?.total;
                const { redirectUri } = value;
                setPayment(value);
                const customerPhone = getCountryCodeAndNumber(value?.eventPageOrder?.customer?.phoneNumber);
                const labelFields = {};
                value?.eventPageOrder?.eventPageOrderLabels?.forEach(labelItem => {
                    if (labelItem?.dataType === 'INPUT_PHONE') {
                        const phoneNumber = parsePhoneNumberFromString(labelItem?.value);
                        labelFields.countryCallingCode = phoneNumber?.countryCallingCode || '1';
                        labelFields.phone = phoneNumber?.nationalNumber;
                    }
                    if (labelItem?.dataType === 'INPUT_EMAIL') {
                        labelFields.email = labelItem?.value;
                    }
                    if (labelItem?.dataType === 'INPUT_NAME' && !labelFields.name) {
                        labelFields.name = labelItem?.value;
                    }
                });
                const disablePhoneOnPromo = !!(((customerPhone?.phoneNumber &&  customerPhone?.countryCode)
                    || (labelFields?.countryCallingCode && labelFields?.phone))
                    && value?.eventPageOrder?.promoCode);
                dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                  value: {
                      phoneNumber: labelFields?.phone || customerPhone?.phoneNumber,
                      countryCode: labelFields?.countryCallingCode ? `+${labelFields?.countryCallingCode}` : customerPhone?.countryCode,
                      name: value?.eventPageOrder?.customer?.name || labelFields?.name,
                      email: value?.eventPageOrder?.customerr?.email || labelFields?.email,
                      disablePhone: disablePhoneOnPromo,
                  } 
                }));
                setShippingAddress(
                    value &&
                    value.eventPageOrder &&
                    value.eventPageOrder.customer &&
                    value.eventPageOrder.customer.shippingAddress
                );
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    setBankImageUrl(value.account && value.account.bankImageUrl);
                    setPartnerImageUrl(value.account && value.account.partnerImageUrl);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                    if (portal) {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
                        setBanksList(supportedBanks);
                    } else {
                        const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
                        setBanksList(supportedBanks);
                    }
                }

                if ((value
                    && value.account
                    && value.account.supportedPaymentTypes
                    && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                if ((value
                    && value.account
                    && value.account.supportedPaymentTypes
                    && value.account.supportedPaymentTypes).includes('APPLE_PAY_US')
                    || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                    getGooglePayMerchantValues(value && value.account && value.account.gid);
                }
                setUserType(value.account && value.account.mdr);
            }
        } catch (e) {
            console.log('ERROR : ', e)
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment?.eventPageOrder?.customer?.gid;
    };

    const chargeByNetBanking = async (data) => {
        const { gid } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };


    const chargeByUpi = async (data) => {
        const { paymentMethod } = data;
        await addCheckoutPageById({
            "paymentMethod": paymentMethod
        });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await addCheckoutPageById({ customer, paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByCard = async (data) => {
        const { paymentMethod, customer, notify } = data;
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentMethod.userAgent = userAgent;
        if (customer.Address) {
            //alert(JSON.stringify(customer.Address))
            delete customer.Address;
        }
        /* if(shippingAddress){
             //alert("abc"+JSON.stringify(shippingAddress))
         delete shippingAddress.country;
         shippingAddress.countryCode = "US";
         customer.shippingAddress = shippingAddress ;}*/
        await addCheckoutPageById({ paymentMethod, customer, shouldWhatsAppNotify: notify });
    };

    const chargeByBank = async (data) => {
        const { customer, fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await addCheckoutPageById({
            customer,
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment)
        });
    };

    const chargeByPaypalGooglePay = async (data) => {
        try {
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                const phoneNumber = data?.paymentMethodData?.info?.billingAddress?.phoneNumber?.replace(/\D/g, '') || "";
                const formattedPhoneNumber = phoneNumber !== "" && data?.paymentMethodData?.info?.billingAddress?.countryCode
                    ? `+${getCountryCallingCode(data?.paymentMethodData?.info?.billingAddress?.countryCode)}${phoneNumber}`
                    : '+14485555555';
                const responseEntity = await addCheckoutPageById({
                    paymentMethod: paymentMethod, customer: {
                        name: data?.shippingAddress?.name ?? data?.paymentMethodData?.info?.billingAddress?.name ?? 'anonymous user',
                        email: data?.email ?? 'anonymous@swirepay.com',
                        phoneNumber: formattedPhoneNumber,
                    }
                }, paypalGooglePayRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(responseEntity.paymentSession.gid, responseEntity.paymentSession.psClientSecret);
                chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        }
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        const phoneNumber = data?.paymentMethodData?.info?.billingAddress?.phoneNumber.replace(/[\s\-]/g, '') || "";
        const formattedPhoneNumber = phoneNumber !== ""
            ? `+${getCountryCallingCode(data?.paymentMethodData?.info?.billingAddress?.countryCode)}${phoneNumber}`
            : "";

        setRecaptchaPaymentType('cardPointGooglePay');
        await addCheckoutPageById({
            paymentMethod: paymentMethod, customer: {
                name: data?.shippingAddress?.name || "",
                email: data?.email || "",
                phoneNumber: formattedPhoneNumber,
            }
        }, cardPointGooglePayToken);
    };

    const chargeByApple = async (paymentData, recaptchaToken = null) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };
        setRecaptchaPaymentType('paypalApplePay');
        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        const responseEntity = await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer
        }, recaptchaToken);
        isPayPalApple.current = false;
        responseEntity.paymentSessionGid = responseEntity?.paymentSession?.gid;
        responseEntity.psClientSecret = responseEntity?.paymentSession?.psClientSecret;
        return responseEntity;
    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;

        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }

        await addCheckoutPageById({
            paymentMethod: paymentMethod,
            customerGid: getCustomerGidFromPayment(payment),
            customer: customer
        }, null);
    };

    const chargeByApplePay = async (stripePaymentMethod, recaptchaToken = null) => {
        // const meta = stripePaymentMethod;
        const paymentMethod = {
            applePayUS: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.billing_details.name,
                email: stripePaymentMethod.billing_details.email,
                phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
                stripePaymentMethodId: stripePaymentMethod.id,
                cardBrand: stripePaymentMethod.card.brand,
                cardExpMonth: stripePaymentMethod.card.exp_month,
                cardExpYear: stripePaymentMethod.card.exp_year,
                cardFundingType: stripePaymentMethod.card.funding,
                applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
                cardLast4: stripePaymentMethod.card.last4,
                billingAddress: {
                    street: stripePaymentMethod.billing_details.address.line1,
                    city: stripePaymentMethod.billing_details.address.city,
                    state: stripePaymentMethod.billing_details.address.state,
                    postalCode: stripePaymentMethod.billing_details.address.postal_code,
                    countryCode: stripePaymentMethod.billing_details.address.country
                },
                name: stripePaymentMethod.name,
                email: stripePaymentMethod.email,
                phone: stripePaymentMethod.phone
            }
        };
        const value = await getPayPalAccountInfo(payment?.account?.gid);
        if (value) {
            isPayPalApple.current = true;
        }
        const responseEntity = await addCheckoutPageById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) }, recaptchaToken);
        return responseEntity;
    };

    const chargeByIdSuccessActions = async (value) => {
        let nextActionUrl;
        let redirectUrl;
        let returnUrl;
        if (value && value.paymentSession) {
            nextActionUrl = value.paymentSession && value.paymentSession.nextActionUrl ? value.paymentSession.nextActionUrl : value.nextActionUrl;
            redirectUrl = value.paymentSession && value.paymentSession.redirectUrl ? value.paymentSession.redirectUrl : value.redirectUrl;
            returnUrl = value.paymentSession && value.paymentSession.returnUrl;
        } else {
            const info = await getEventPageOrderDetailsById(eventPageOrderLinkId, null);
            nextActionUrl = info && info.paymentSession && info.paymentSession.nextActionUrl;
            redirectUrl = value && value.redirectUrl;
        }
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        if (value?.paymentSession?.status === 'REQUIRE_CONFIRMATION') {
            setManualPlaidPayment(true);
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        const timeOut = value?.paymentSession?.status === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID : 10000;
        setTimeout(function () {
            const redirectUri = returnUrl ? returnUrl : redirectUrl ? redirectUrl : SWIREPAY_URL;
            window.location = redirectUri;
            sessionStorage.removeItem("stripeRes");
            expiredToken();
            localStorage.removeItem('eventsPayload');
        }, timeOut);
        if (eventPageOrderLinkId) {
            localStorage.removeItem(`${eventPageOrderLinkId}-tap-index`);
            localStorage.removeItem(`${eventPageOrderLinkId}-tab-name`);
        }
    };

    const addCheckoutPageById = async (data, recaptchaToken = null) => {
        data.surchargeApplicable = payment?.account?.surchargeType === 'OPTIONAL' && payment?.eventPage?.surchargeEnabled
            ? optionalCheck : (payment?.account?.surchargeType !== 'NONE')
                ? true : false;
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await addEventPageOrderChargeById(eventPageOrderLinkId, payload);
                        if (value) {
                            if (!isPayPalApple.current
                                && !isPayPalGoogle.current
                            ) {
                                await chargeByIdSuccessActions(value);
                            }
                            return value;
                        }
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429) {
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkGlobalRecaptcha(token);
                break;
            case 'paypalApplePay':
                setPaypalApplePayRecaptcha(token);
                setPaypalApplePayMessageModal(true);
                break;
            case 'paypalGooglePay':
                setPaypalGooglePayRecaptchaToken(token);
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await addCheckoutPageById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const getCheckoutById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getCheckoutReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-event-page-order=${payment?.eventPageOrder?.gid || eventPageOrderLinkId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-event-page-order=${payment?.eventPageOrder?.gid || eventPageOrderLinkId}`;
                        }
                    }, timeOut);
                    if (eventPageOrderLinkId) {
                        localStorage.removeItem(`${eventPageOrderLinkId}-tap-index`);
                        localStorage.removeItem(`${eventPageOrderLinkId}-tab-name`);
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    expiredToken();
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&sp-event-page-order=${payment?.eventPageOrder?.gid || eventPageOrderLinkId}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?sp-event-page-order=${payment?.eventPageOrder?.gid || eventPageOrderLinkId}`;
                        }
                    }, timeOut);
                    if (eventPageOrderLinkId) {
                        localStorage.removeItem(`${eventPageOrderLinkId}-tap-index`)
                        localStorage.removeItem(`${eventPageOrderLinkId}-tab-name`);
                    }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const cancelAlertOpen = () => {
        setAlertConfig({
            showIcon: true,
            isOpen: true,
            hideBtn: false,
            cancel: resetAlertConfig,
            header: "Are you sure!",
            body: "You will not be able to recover this payment link",
            submitBtnText: "Yes, decline it!",
            cancelBtnText: "Cancel",
            showCancelBtn: true,
            showSubmitBtn: true,
            submit: declinePaymentLink,
            icon: WARNING_ICON
        });
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const declinePaymentLink = () => {
        setAlertConfig({
            ...defaultAlertConfig,
            showIcon: true,
            isOpen: true,
            hideBtn: true,
            header: `Please Wait!. Your payment link decline is being processed`,
            body: "You will be redirected when the decline is successful.",
        });
        if (payment && payment.gid) {
            declinePaymentLinkByGid(payment.gid).then(value => {
                if (value) {
                    const { redirectUri } = value;
                    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                    setAlertConfig({
                        ...defaultAlertConfig,
                        showIcon: true, isOpen: true, hideBtn: true,
                        header: "PaymentLink Decline Completed", body: "You will be redirected automatically.",
                        icon: SUCCESS_ICON
                    });
                    setTimeout(function () {
                        const redirectUrl = redirectUri || SWIREPAY_URL;
                        const urlPath = redirectUrl.includes("?");
                        const decline = "decline=true";
                        if (urlPath) {
                            window.location = `${redirectUrl}&${decline}`;
                        } else if (!urlPath) {
                            window.location = `${redirectUrl}?${decline}`;
                        }
                    }, timeOut);
                }
            }).catch(reason => error(reason));
        }
    };

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSession?.gid, orderDatas?.paymentSession?.psClientSecret);
            setTransactionSuccessModalOpen(true);
            chargeByIdSuccessActions(orderDatas);
        } catch (error) {
          console.error(error);
          throw error;
        }
      };
    
      const createOrder = async (paypalData, actions) => {
        try {
          const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
          if (values?.public_key) {
            const keys = generateClientKeyPair();
            if (keys?.privateKey) {
                let data = {};
                const userAgent = {
                    acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
                    ip: ipAddress,
                    language: window.navigator.language,
                    colorDepth: window.screen.colorDepth,
                    screenHeight: window.screen.height,
                    screenWidth: window.screen.width,
                    timeZone: new Date().getTimezoneOffset(),
                    browserUserAgent: window.navigator.userAgent
                };
                let customer = {};
            customer.email = payment?.eventPageOrder?.customer?.email;
            customer.phoneNumber = payment?.eventPageOrder?.customer?.phoneNumber;
            customer.name = payment?.eventPageOrder?.customer?.name;
              if (paypalData?.paymentSource === 'paypal') {
                data = {
                  customer,
                  userAgent: userAgent,
                  shouldWhatsAppNotify: false,
                  paymentMethod: {
                    payPalWallet: {
                      rawData: {
                        experience_context: {
                          payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                          landing_page: "LOGIN",
                          return_url: SWIREPAY_URL,
                          cancel_url: SWIREPAY_URL,
                        }
                      }
                    },
                    type: "WALLET",
                    subType: "PAYPAL_WALLET",
                  }
                };
              } else if (paypalData?.paymentSource === 'venmo') {
                data = {
                  customer,
                  userAgent: userAgent,
                  shouldWhatsAppNotify: false,
                  paymentMethod: {
                    venmo: {
                      rawData: {
                        experience_context: {
                          payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                          landing_page: "LOGIN",
                          return_url: SWIREPAY_URL,
                          cancel_url: SWIREPAY_URL,
                        }
                      }
                    },
                    type: "WALLET",
                    subType: "VENMO",
                  }
                };
              }
              const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
              const payload = {
                publicKey: keys?.publicKey,
                keyId: encriptedData?.keyId,
                iv: encriptedData?.iv,
                data: encriptedData?.encryptedData,
              }
              if (encriptedData?.keyId) {
                const value = await addEventPageOrderChargeById(eventPageOrderLinkId, payload);
                commonRecaptchaToken.current = null;
                if (value?.paymentSession?.gid) {
                  setOrderData(value)
                  const orderData = await getWalletOrderInfo(value?.paymentSession?.gid, value?.paymentSession?.psClientSecret);
                  if (!orderData.id) {
                    const errorDetail = orderData.details[0];
                    const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : "Unexpected error occurred, please try again.";
    
                    throw new Error(errorMessage);
                  }
                  return orderData?.id;
                }
              }
            }
          }
        } catch (error) {
          if (error?.status === 429) {
            setSavedPaymentDetails(paypalData);
            setRecaptchaPaymentType('payPalButton');
            setRecaptchaModalVisible(true);
            setTransactionModalOpen(false);
            throw new Error('Recatpcha Required');
          }
          console.error(error);
          throw error || new Error('Unexpected error occurred, please try again.');
        }
      };

    const chargeBySavedPaymentMethods = async (data) => {
      await addCheckoutPageById({
        paymentMethod: data,
        customer: {
          name: payment?.eventPageOrder?.customer?.name,
          email: payment?.eventPageOrder?.customer?.email,
          phoneNumber: payment?.eventPageOrder?.customer?.phoneNumber,
        }
      });
    };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    //alert(JSON.stringify(uniquePaymentTypes));
    if (uniquePaymentTypes.includes('APPLE_PAY_US')) {
        const index = uniquePaymentTypes.indexOf('APPLE_PAY_US');
        if (index > -1) {
            uniquePaymentTypes.splice(index, 1);
        }
    }

    const customerInfo = useMemo(() => {
        if (payment?.eventPageOrder?.customer) {
            return payment.eventPageOrder.customer;
        }
        const customerInfo = {};
        const labels = payment?.eventPageOrder?.eventPageOrderLabels;
        if (Array.isArray(labels)
            && labels.length > 0
        ) {
            labels.forEach(label => {
                switch (label?.dataType) {
                    case 'INPUT_PHONE':
                        customerInfo.phoneNumber = label?.value;
                        break;
                    case 'INPUT_EMAIL':
                        customerInfo.email = label?.value;
                        break;
                    case 'INPUT_NAME':
                        if (!customerInfo.name) {
                            customerInfo.name = label?.value;
                        }
                        break;
                    default:
                }
            });
            return customerInfo;
        }
        return null;
    }, [payment]);

    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
                customerDisabled={false}
                headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                payments={payment?.account?.gid}
                // isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={eventPageOrderLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                // showBillDetails={true}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                // charges={true}
                // convenience={convenience}
                // gst={gst}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(payment && payment.eventPageOrder.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.eventPageOrder.total), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={totalAmount}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                amount={subTotal}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={payment?.eventPage?.surchargeEnabled}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                clearZipCode={true}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            preFillCustomer={payment && payment.eventPageOrder && payment.eventPageOrder.customer}
                            chargeByGooglePay={chargeByGooglePay}
                            errorMsg={errorMessage}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorHeader={null}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}
                            paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.EVENT_PAGE_ORDER_LINK}/${eventPageOrderLinkId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                headerText={"PAY WITH WALLET Alias"}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
                submit={chargeBySwirepayUS}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                upiUrl={`${BASE_URLS.EVENT_PAGE_ORDER_LINK}/${eventPageOrderLinkId}`}
                buttonText={submitBtnText}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                amount={subTotal}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={cancelAlertOpen}
                hideCustomer={false}
                errorMsg={errorMessage}
                upiError={upiError}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={customerInfo}
                phoneInputReadOnly={payment?.eventPageOrder?.promoCode && customerInfo?.phoneNumber}
                headerText={"Pay With Card"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                customerValidation={true}
                prefix={payment && payment.account.currency && payment.account.currency.prefix}
                billAmountApple={AmountDivideByHundred(payment && payment.eventPageOrder.total)}
                billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.eventPageOrder.total), payment && payment.account.currency && payment.account.currency.name)}`}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                getPaymentCharges={getPaymentCharges}
                totalAmount={subTotal}
                userType={userType}
                payments={payment && payment}
                ApplePayment={applePayment}
                payment={payment}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                isShippingAddressRequired={(payment && payment.account && payment.account.collectShippingAddress)}
                chargeByApplePay={chargeByApplePay}
                chargeByApple={chargeByApple}
                showWhatsAppNotify={true}
                amount={subTotal}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={payment?.eventPage?.surchargeEnabled}
                totalPayable={totalPayable}
                discount={discount}
                subTotal={subTotal}
                serviceFee={feeService}
                serviceFeeRate={feeService}
                serviceFeeRateVal={feeService}
                serviceFeeVal={feeService}
                tax={finalTax}
                tip={finalTip}
                surcharge={surcharge}
                clearZipCode={true}
            />,
            id: 'CARD'
        }


    ]

    const tabPanelsApple =

    { //children :  <Apple amount={AmountDivideByHundred(payment && payment.eventPageOrder.total)} chargeByApple={chargeByApple} payment={payment}/>
        children: <>
            {
                payPalClientAuth ? (
                    <ApplePayButton
                        recaptchaToken={paypalApplePayRecaptcha}
                        amount={payment && payment.eventPageOrder.total}
                        chargeByApple={chargeByApple}
                        payment={payment}
                        accountGid={payment?.account?.gid}
                        successCallback={chargeByIdSuccessActions}
                        failCallback={chargeByIdFailActions}
                    />
                ) : (
                    <>
                        {
                            applePayment && isApplePay ? <Apple amount={payment && payment.eventPageOrder.total} chargeByApple={chargeByCardpointeApplePay} payment={payment} /> : null
                        }
                    </>
                )
            }
        </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    }
        ;

    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
        children: <SavedPaymentMethods
                    buttonText={submitBtnText}
                    submit={chargeBySavedPaymentMethods}
                    supportedPaymentTypes={uniquePaymentTypes}
                  />,
        id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth && payPalClientId) {
      tabPanels.push({
        children: <div style={{ width: '200px'}} >
          <PayPalCheckout
            styles={{ shape: "rect", layout: "vertical" }}
            createOrder={createOrder}
            onApprove={onApprove}
            payPalClientId={payPalClientId}
            currency={payment?.account?.currency?.name || 'USD'}
            country={payment?.account?.country?.alpha2 || 'US'}
          />
        </div>,
        id: 'PAYPAL_METHOD',
      });
      uniquePaymentTypes.push('PAYPAL_METHOD');
    }

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;

    return (
        <BaseSplitPage
            errorHeader={null}
            errorMsg={errorMessage}
            left={
                <>
                    <FlexContainer
                        flexDirection="column"
                        position="relative"
                        display="block"
                        height="100%"
                    >
                        <div>
                            {
                                (payment && payment.account && payment.account.largeLogo) && (
                                    <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                                )
                            }
                            <H1Text>
                                Payment Checkout
                            </H1Text>
                            {
                                ossatId.includes(eventPageOrderLinkId) ? (
                                    <Row>
                                        <Col className="mt-2"
                                            style={{ fontWeight: '600', fontSize: '18px', marginLeft: "0px", color: '#1B1B1B' }}>
                                            Payment For :
                                        </Col>
                                    </Row>
                                ) : (
                                    <div className="mb-2" style={{ fontWeight: '400', fontSize: '14px', color: '#909090' }}>
                                        Payment For
                                    </div>
                                )
                            }
                            
                            <Row>
                                <Col className="mt-2"
                                    style={{ fontWeight: '600', fontSize: '18px', marginLeft: "0px", color: '#1B1B1B' }}>
                                    {(payment && payment.description) || (payment && payment.account && payment.account.name && payment.account.name === 'Shastha Fresh Delivery Store' ? 'Shastha Fresh' : (payment && payment.account && payment.account.name))}
                                </Col>
                            </Row>
                            <div className="mt-3 mb-3" style={{ fontWeight: '400', fontSize: '13px', color: '#474747' }}>
                                <p>
                                    Reference Id: {
                                        (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
                                    }
                                </p>
                            </div>
                            {
                                tabName === 'UPI' && (
                                    <>
                                        <H2Text>
                                            Amount
                                        </H2Text>
                                        <DescriptionText fontSize="24px">
                                            {payment ? `${currencyFormatter(AmountDivideByHundred(payment.eventPageOrder.total), payment.account.currency && payment.account.currency.name)}` : null}
                                        </DescriptionText>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ position: "sticky", top: "85%" }}>
                            <Support email={payment && payment.support && payment.support.email}
                                phone={payment && payment.support && (payment.account.gid === 'account-25729ddf59914c9abcb41a107d824330' ? '+16507435681' : payment.support.phone)}
                                whiteLabel={payment && payment.account && payment.account.whiteLabel}
                                partnerImageUrl={partnerImageUrl}
                                bankImageUrl={bankImageUrl} />
                            {agregatorName === 'EPAYMENTS' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }}>
                                    <a href="https://www.swirepay.com" target="_blank">
                                        <img src={EPaymentImg} alt="" />
                                    </a>
                                </div>
                                :
                                agregatorName === 'OMEGAITR' ?
                                    <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }}>
                                        <a href="https://www.swirepay.com" target="_blank">
                                            <img src={OMEGAITRlogo} alt="" />
                                        </a>
                                    </div>
                                    :
                                    ''
                            }

                        </div>
                    </FlexContainer>
                </>
            } right={
                <>
                    <Header
                        payment={payment}
                        bankImageUrl={bankImageUrl}
                        tabName={tabName}
                        cancelUrlLink={null}
                    />
                    {payment?.account?.country?.alpha2 === 'US' ? (
                      <PaymentExpandableRowsV2
                        id={eventPageOrderLinkId}
                        paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                        tabs={uniquePaymentTypes}
                        tabPanels={tabPanels}
                        defaultSelectedTab={selectedTab || 0}
                        onSelect={data => setSelectedTab(data)}
                        tabName={tabName}
                        upiDown={upiDownTime}
                        applePayment={applePayment}
                        isApplePay={isApplePay}
                        accountGid={payment?.account?.gid}
                        getCurrentTab={getCurrentTab}
                      />) : (
                      <PaymentExpandableRows
                          id={eventPageOrderLinkId}
                          paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                          tabs={uniquePaymentTypes}
                          tabPanels={tabPanels}
                          defaultSelectedTab={selectedTab || 0}
                          onSelect={data => setSelectedTab(data)}
                          tabName={tabName}
                          upiDown={upiDownTime}
                          applePayment={applePayment}
                          isApplePay={isApplePay}
                          accountGid={payment?.account?.gid}
                          getCurrentTab={getCurrentTab}
                      />)}
                    <SmallScreenFooter
                        partnerImageUrl={partnerImageUrl}
                        bankImageUrl={bankImageUrl}
                        whiteLabel={payment && payment.account && payment.account.whiteLabel}
                    />
                    <RecaptchaModal
                        visible={recaptchaModalVisible}
                        onVerified={onGlobalCaptchaVerified}
                    />
                    <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                    <SuccessModal isOpen={isTransactionSuccessModalOpen} manualPlaidPayment={manualPlaidPayment} />
                    <AlertModal
                        showIcon={alertConfig.showIcon}
                        isOpen={alertConfig.isOpen}
                        hideBtn={alertConfig.hideBtn}
                        cancel={alertConfig.cancel}
                        header={alertConfig.header}
                        body={alertConfig.body}
                        submitBtnText={alertConfig.submitBtnText}
                        cancelBtnText={alertConfig.cancelBtnText}
                        showCancelBtn={alertConfig.showCancelBtn}
                        showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                    <Spinner isOpen={isShowSpinner} />
                </>
            } />
    )
};

export default EventPagePay;